import script from "./material1.vue?vue&type=script&setup=true&lang=js"
export * from "./material1.vue?vue&type=script&setup=true&lang=js"

import "./material1.vue?vue&type=style&index=0&id=7198f1d1&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7198f1d1"]])

export default __exports__